import React, { useEffect, useContext, useState } from 'react';
import './aboutus.scss';
import { CSSTransition } from 'react-transition-group';
import Slider from './Slider';
import Links from './Links';

// Dialog Window
import Dialog from '../../Helpers/Dialog';

// Video Player
import VideoPlayer from '../../Helpers/VideoPlayer';

// Subpages
import History from './Subpages/History';
import Philosophy from './Subpages/Philosophy';
import Commitment from './Subpages/Commitment';
import Departments from './Subpages/Departments';
import VirtualTools from './Subpages/VirtualTools';
import VirtualTour from './Subpages/VirtualTour';

// CONTEXT
import AboutusContext from '../../../contexts/pages/aboutus/aboutusContext';
import AboutusDepartmentsContext from '../../../contexts/pages/aboutus/departments/departmentsContext';
import { secundaryPagesContext } from '../../../contexts/pages/aboutus/secundaryPages/secundaryPagesContext';
import { videoPlayerContext } from '../../../contexts/helpers/videoPlayer/videoPlayerContext';
import Foundation from './Subpages/Foundation';
import Anthem from './Subpages/Anthem/Anthem';


const AboutusPage = () => {

    const aboutusContext = useContext(AboutusContext);
    const { getAboutus } = aboutusContext;
    

    const aboutusDepartmentsContext = useContext(AboutusDepartmentsContext)
    const { getDepartments } = aboutusDepartmentsContext;

    const VideoPlayerContext = useContext(videoPlayerContext);
    const { handleDeactivatePlayer } = VideoPlayerContext;

    const [linkState, setLinkState]  = useState({
        foundationLinkState:false,
        philosophyLinkState:false,
        departmentsLinkState:false,
        commitmentLinkState:false,
        anthemLinkState:false,
        virtualTourLinkState:false,
    })

    const handleCurrentLinkState = (newLinkState) => {
        setLinkState({
            ...newLinkState
        })
    }

    const aboutusPagesContext = useContext(secundaryPagesContext);
    const {
        foundationState,
        setFoundationState,
        philosophyState,
        setPhilosophyState,
        departmentsState,
        setDepartmentsState,
        commitmentState,
        setCommitmentState,
        anthemState,
        setAnthemState,
        virtualTourState,
        setVirtualTourState,
    } = aboutusPagesContext;

    const animationStates = {
        foundationState,
        setFoundationState,
        philosophyState,
        setPhilosophyState,
        departmentsState,
        setDepartmentsState,
        commitmentState,
        setCommitmentState,
        anthemState,
        setAnthemState,
        virtualTourState,
        setVirtualTourState
    }

    useEffect(() => {
        getAboutus()
        getDepartments()
        handleDeactivatePlayer()
        if (
            !foundationState.active &&
            !philosophyState.active &&
            !departmentsState.active &&
            !commitmentState.active &&
            !anthemState.active &&
            !virtualTourState.active
        ) {
            setFoundationState({ enter: false, active: true });
        }
        // eslint-disable-next-line 
    }, [])

    return (
        <div className="row aboutus-body">
            {/* <Slider ClassName={'aboutus-slider'} /> */}

            <CSSTransition
                in={foundationState.active}
                timeout={500}
                classNames="history-subarea"
                unmountOnExit
                onEnter={() => {
                    setPhilosophyState({ enter: false, active: false });
                    setCommitmentState({ enter: false, active: false });
                    setDepartmentsState({ enter: false, active: false });
                    setAnthemState({ enter: false, active: false });
                    setVirtualTourState({ enter: false, active: false });
                }}
                onExited={() => {
                    if (philosophyState.enter) setPhilosophyState({ ...philosophyState, active: true });
                    if (commitmentState.enter) setCommitmentState({ ...commitmentState, active: true });
                    if (departmentsState.enter) setDepartmentsState({ ...departmentsState, active: true });
                    if (anthemState.enter) setAnthemState({ ...anthemState, active: true });
                    if (virtualTourState.enter) setVirtualTourState({ ...virtualTourState, active: true });
                }}
            >
                <Foundation />
            </CSSTransition>

             <CSSTransition
                in={philosophyState.active}
                timeout={500}
                classNames="philosophy-subarea"
                unmountOnExit
                onEnter={() => {
                    setFoundationState({ enter: false, active: false });
                    setDepartmentsState({ enter: false, active: false });
                    setCommitmentState({ enter: false, active: false });
                    setAnthemState({ enter: false, active: false });
                    setVirtualTourState({ enter: false, active: false });
                }}
                onExited={() => {
                    if (foundationState.enter) setFoundationState({ ...foundationState, active: true });
                    if (departmentsState.enter) setDepartmentsState({ ...departmentsState, active: true });
                    if (commitmentState.enter) setCommitmentState({ ...commitmentState, active: true });
                    if (anthemState.enter) setAnthemState({ ...anthemState, active: true });
                    if (virtualTourState.enter) setVirtualTourState({ ...virtualTourState, active: true });
                }}
            >
                <Philosophy />
            </CSSTransition>

            <CSSTransition
                in={departmentsState.active}
                timeout={500}
                classNames="departments-subarea"
                unmountOnExit
                onEnter={() => {
                    setFoundationState({ enter: false, active: false });
                    setPhilosophyState({ enter: false, active: false });
                    setCommitmentState({ enter: false, active: false });
                    setAnthemState({ enter: false, active: false });
                    setVirtualTourState({ enter: false, active: false });
                }}
                onExited={() => {
                    if (foundationState.enter) setFoundationState({ ...foundationState, active: true });
                    if (philosophyState.enter) setPhilosophyState({ ...philosophyState, active: true });
                    if (commitmentState.enter) setCommitmentState({ ...commitmentState, active: true });
                    if (anthemState.enter) setAnthemState({ ...anthemState, active: true });
                    if (virtualTourState.enter) setVirtualTourState({ ...virtualTourState, active: true });
                }}
            >
                <Departments />
            </CSSTransition> 

              <CSSTransition
                in={commitmentState.active}
                timeout={500}
                classNames="commitment-subarea"
                unmountOnExit
                onEnter={() => {
                    setFoundationState({ enter: false, active: false });
                    setPhilosophyState({ enter: false, active: false });
                    setDepartmentsState({ enter: false, active: false });
                    setAnthemState({ enter: false, active: false });
                    setVirtualTourState({ enter: false, active: false });
                }}
                onExited={() => {
                    if (foundationState.enter) setFoundationState({ ...foundationState, active: true });
                    if (philosophyState.enter) setPhilosophyState({ ...philosophyState, active: true });
                    if (departmentsState.enter) setDepartmentsState({ ...departmentsState, active: true });
                    if (anthemState.enter) setAnthemState({ ...anthemState, active: true });
                    if (virtualTourState.enter) setVirtualTourState({ ...virtualTourState, active: true });
                }}
            >
                <Commitment />
            </CSSTransition>

            <CSSTransition
                in={anthemState.active}
                timeout={500}
                classNames="vitual-tour-subarea"
                unmountOnExit
                onEnter={() => {
                    setFoundationState({ enter: false, active: false });
                    setPhilosophyState({ enter: false, active: false });
                    setDepartmentsState({ enter: false, active: false });
                    setCommitmentState({ enter: false, active: false });
                    setVirtualTourState({ enter: false, active: false });
                }}
                onExited={() => {
                    if (foundationState.enter) setFoundationState({ ...foundationState, active: true });
                    if (philosophyState.enter) setPhilosophyState({ ...philosophyState, active: true });
                    if (departmentsState.enter) setDepartmentsState({ ...departmentsState, active: true });
                    if (commitmentState.enter) setCommitmentState({ ...commitmentState, active: true });
                    if (virtualTourState.enter) setVirtualTourState({ ...virtualTourState, active: true });
                }}
            >
                <Anthem />
            </CSSTransition>


             <CSSTransition
                in={virtualTourState.active}
                timeout={500}
                classNames="vitual-tour-subarea"
                unmountOnExit
                onEnter={() => {
                    setFoundationState({ enter: false, active: false });
                    setPhilosophyState({ enter: false, active: false });
                    setDepartmentsState({ enter: false, active: false });
                    setCommitmentState({ enter: false, active: false });
                    setAnthemState({ enter: false, active: false });
                }}
                onExited={() => {
                    if (foundationState.enter) setFoundationState({ ...foundationState, active: true });
                    if (philosophyState.enter) setPhilosophyState({ ...philosophyState, active: true });
                    if (departmentsState.enter) setDepartmentsState({ ...departmentsState, active: true });
                    if (commitmentState.enter) setCommitmentState({ ...commitmentState, active: true });
                    if (anthemState.enter) setAnthemState({ ...anthemState, active: true });
                }}
            >
                <VirtualTour />
            </CSSTransition>


            <VideoPlayer />
            <Links animationStates={animationStates} linkState={linkState} handleCurrentLinkState={handleCurrentLinkState} />
            <Dialog />
        </div >
    );
}

export default AboutusPage;